import { useCallback } from 'react'

import { createReferralSignatureMessage, getChainType } from '@/utils'
import { WalletContextType } from '@/wallets'

import { TFunction } from 'i18next'

export const useReferralSignature = (
  referralWallet: WalletContextType | undefined,
  t: TFunction<'translation', undefined>
) => {
  return useCallback(
    async (code: string) => {
      const timestamp = Date.now()
      const messages = createReferralSignatureMessage(referralWallet?.address || '', code, timestamp)
      const signature =
        (await referralWallet?.wallet?.signMessage(messages, referralWallet?.network || '', {
          btcSignMessageType: 'ecdsa',
        })) || ''
      const publicKey = await referralWallet?.wallet?.getCompressedPublicKey(
        referralWallet?.networkInfo?.networkId || ''
      )
      const chainType = getChainType(referralWallet?.networkInfo?.networkId || '')
      if (!chainType) {
        throw new Error(t('error.INVALID_NETWORK_TYPE'))
      }
      return { signature, publicKey, chainType, timestamp }
    },
    [referralWallet, t]
  )
}
